import { render } from "./BreakfastAvailability.vue?vue&type=template&id=6b1a20e8&scoped=true"
import script from "./BreakfastAvailability.vue?vue&type=script&lang=js"
export * from "./BreakfastAvailability.vue?vue&type=script&lang=js"

import "./BreakfastAvailability.vue?vue&type=style&index=0&id=6b1a20e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1a20e8"]])

export default __exports__